import { TagInfo } from './tag-info.model';
/**
 * タグ選択画面のタググループクラス
 *
 * @export TagGroupInfo
 * @class TagGroupInfo
 */
export class TagGroupInfo {
  open = false;
  constructor(
    public tagGroupId: string,
    public tagGroupName: string,
    public tags: TagInfo[]
  ) {}
}
